import { render } from "./save_template_overlay.vue?vue&type=template&id=33b54a33&scoped=true"
import script from "./save_template_overlay.vue?vue&type=script&lang=js"
export * from "./save_template_overlay.vue?vue&type=script&lang=js"

import "./save_template_overlay.vue?vue&type=style&index=0&id=33b54a33&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b54a33"]])

export default __exports__